module.exports = __webpack_public_path__ + "img/AppFailed.00919a67.svg";